/** Форматирование чисел и времени.
 *
 * Собрано в одном месте не ради экономии строк, а ради единообразия:
 * время партии, время рекорда и время в таблице обязаны выглядеть
 * одинаково, иначе игрок начнёт их сравнивать неправильно.
 */

import { getLanguage } from '../i18n'

/** Время партии: «12:41», а для длинных партий «1:12:41». */
export function formatTime(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const seconds = total % 60
  const minutes = Math.floor(total / 60) % 60
  const hours = Math.floor(total / 3600)

  const tail = `${minutes}:${String(seconds).padStart(2, '0')}`
  if (!hours) return tail
  return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** Разница во времени для таблицы: «9 секунд», «1:20». */
export function formatGap(ms: number): string {
  if (ms < 60_000) return `${Math.max(1, Math.round(ms / 1000))}`
  return formatTime(ms)
}

/**
 * Большие числа с неразрывным пробелом: «128 400».
 *
 * Пробел именно неразрывный — иначе очки переносятся на другую строку
 * посередине числа.
 */
export function formatNumber(value: number): string {
  return value.toLocaleString(getLanguage() === 'en' ? 'en-US' : 'ru-RU').replace(/\s/g, ' ')
}

/** Множитель: «×1,4» по-русски и «×1.4» по-английски. */
export function formatMultiplier(value: number): string {
  const text = value.toFixed(1)
  return `×${getLanguage() === 'en' ? text : text.replace('.', ',')}`
}

/** Дата задачи дня: «31 июля». */
export function formatDay(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleDateString(getLanguage() === 'en' ? 'en-US' : 'ru-RU', {
    day: 'numeric',
    month: 'long',
  })
}

/** Часы до момента: «через 6 ч» для бесплатной подсказки. */
export function hoursUntil(iso: string | null): number {
  if (!iso) return 0
  const target = new Date(iso).getTime()
  if (Number.isNaN(target)) return 0
  return Math.max(1, Math.ceil((target - Date.now()) / 3_600_000))
}
